import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HomeNavbar from "../components/HomeNavbar";
import StoreModal from "../components/StoreModal";
import Toast from "../components/Toast";
import "./HomePage.css";
import { useProduct } from "@/betby/hooks/useProduct";
import { clearSetupThrottle } from "@/betby/viewmodels/useBetbyRendererViewModel";

// Game data
const winGames = [
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/bg001.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/bg002.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/bg003.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/bg004.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/bg005.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep001.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep002.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep003.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep004.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep005.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep006.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep007.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep008.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep009.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep010.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep011.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep012.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep013.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep014.png",
  },
  {
    image:
      "https://oss-us-dzsport-hot-prod.oss-us-west-1.aliyuncs.com/resources/icon/game/ep015.png",
  },
];

const joitGames = [
  {
    image: "/images/game-1.webp",
  },
  {
    image: "/images/game-2.webp",
  },
  {
    image: "/images/game-3.webp",
  },
  {
    image: "/images/game-1.webp",
  },
  {
    image: "/images/game-2.webp",
  },
  {
    image: "/images/game-3.webp",
  },
  {
    image: "/images/game-1.webp",
  },
  {
    image: "/images/game-2.webp",
  },
  {
    image: "/images/game-3.webp",
  },
];

// Sports data
const winSports = [
  {
    image:
      "https://mediumrare.imgix.net/soccer-en.png?w=180&h=236&fit=min&auto=format",
  },
  {
    image:
      "https://mediumrare.imgix.net/basketball-en.png?w=180&h=236&fit=min&auto=format",
  },
  {
    image:
      "https://mediumrare.imgix.net/tennis-en.png?w=180&h=236&fit=min&auto=format",
  },
];

// Sports data
const joitSports = [
  {
    image: "/images/soccer.jpg",
  },
  {
    image: "/images/basketball.jpg",
  },
  {
    image: "/images/tennis.jpg",
  },
];

const sportPath = ["soccer-1", "basketball-2", "tennis-5"];

const HomePage = () => {
  const { isWinburst } = useProduct();
  const sports = isWinburst ? winSports : joitSports;
  const games = isWinburst ? winGames : joitGames;

  const navigate = useNavigate();
  const [viewAllStates, setViewAllStates] = useState({
    sports: false,
    games: true,
  });
  const [showStore, setShowStore] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "" });
  useEffect(() => {
    clearSetupThrottle();
  }, []);
  const toggleViewAll = (type) => {
    setViewAllStates((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  // 跳转到 sportsbook 页面
  const openSportBook = (path = "") => {
    const targetPath = path ? `/sportsbook/${path}` : "/sportsbook";
    navigate(targetPath);
  };

  const showComingSoon = () => {
    setToast({ show: true, message: "Coming Soon!" });
    setTimeout(() => {
      setToast({ show: false, message: "" });
    }, 3000);
  };

  const displaySports = viewAllStates.sports ? sports : sports.slice(0, 8);
  const displayGames = viewAllStates.games ? games : games.slice(0, 8);

  return (
    <div className="homepage">
      <HomeNavbar onOpenStore={() => setShowStore(true)} />

      <main className="main-content">
        <section className="hero-section">
          <h1 className="hero-title">Premium Gaming Experience</h1>
          <p className="hero-subtitle">
            Discover the ultimate gaming platform with cutting-edge technology
            and unparalleled entertainment
          </p>
        </section>

        <section className="section">
          <div className="section-header">
            <h2 className="section-title">Trending Sports</h2>
            <div
              className="view-all-btn"
              onClick={() => toggleViewAll("sports")}
            >
              {viewAllStates.sports ? "Collapse" : "View All"}
            </div>
          </div>
          <div className="sports-grid">
            {displaySports.map((sport, index) => (
              <div
                key={index}
                className="sport-card"
                onClick={() => openSportBook(sportPath[index])}
              >
                <img
                  src={sport.image}
                  alt="Sport"
                  className="sport-image"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <h2 className="section-title">Trending Games</h2>
            <div
              className="view-all-btn"
              onClick={() => toggleViewAll("games")}
            >
              {viewAllStates.games ? "Collapse" : "View All"}
            </div>
          </div>
          <div className="games-grid">
            {displayGames.map((game, index) => (
              <div key={index} className="game-card" onClick={showComingSoon}>
                <img
                  src={game.image}
                  alt="Game"
                  className="game-image"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </section>
      </main>

      <StoreModal isOpen={showStore} onClose={() => setShowStore(false)} />

      <Toast
        show={toast.show}
        message={toast.message}
        onClose={() => setToast({ show: false, message: "" })}
      />
      <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
        <div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              color: "white",
              alignItems: "center",
              paddingBottom: "20px",
              marginRight: "200px",
            }}
          >
            <span>Company Name: Bungie Softworks Limited</span>
            <span>Company Registration Number: 805368893</span>
            <span>
              Address: 5900 balcones drive suite 100 Austin, TX 78731, USA
            </span>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <a href="/terms.html" style={{ textDecoration: "underline" }}>
            Terms of Use
          </a>
          <a href="/rules.html" style={{ textDecoration: "underline" }}>
            Betting Rules
          </a>
          <div>support: support@bungiesofts.com</div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
